export const apenasNumeros = (value: string | undefined) =>
  value?.replace(/[^0-9]/g, "");

export const FormatMoney = (value?: string) => {
  const replace1 = value?.replace(/\D/g, "");
  const replace2 = replace1?.replace(/(\d)(\d{2})$/, "$1,$2");
  const replace3 = replace2?.replace(/(?=(\d{3})+(\D))\B/g, ".");

  return replace3 as string;
};
// expected => '12.300,00' => 12300.00
export const handleFormatToNumeric = (value?: string) => {
  const newValue = value?.length === 2 ? `0,${value}` : value;


  const formatRemoveCaracters = newValue?.replace(/\./g, "").replace(",", ".");
  const formatValueTwoFixed = Number(formatRemoveCaracters).toFixed(2);

  return formatValueTwoFixed;
};

// expected 1000 => 1000 | 25,34 => 2534
export const handleFormatPercent = (value: string) => {
  const resultFormat = value.replace(/[^\d.]/g, "");

  return resultFormat;
};
